var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConditionWait(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.807617,
    width: 40,
    height: 40,
    rx: 8,
    fill: "#F3F4F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 29.8076C15.5375 29.8076 11.5 25.7702 11.5 20.8076C11.5 15.8451 15.5375 11.8076 20.5 11.8076C25.4625 11.8076 29.5 15.8451 29.5 20.8076C29.5 25.7702 25.4643 29.8076 20.5 29.8076ZM20.5 13.1509C16.2781 13.1509 12.8433 16.5857 12.8433 20.8076C12.8433 25.0296 16.2781 28.4643 20.5 28.4643C24.7219 28.4643 28.1567 25.0296 28.1567 20.8076C28.1567 16.5857 24.7219 13.1509 20.5 13.1509Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5389 15.7377C20.9041 15.7377 21.2002 16.0337 21.2002 16.399V20.5338L23.6517 22.9853C23.91 23.2436 23.91 23.6623 23.6517 23.9205C23.3935 24.1788 22.9748 24.1788 22.7165 23.9205L20.0713 21.2753C19.9472 21.1513 19.8776 20.9831 19.8776 20.8077V16.399C19.8776 16.0337 20.1736 15.7377 20.5389 15.7377Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConditionWait);
export default __webpack_public_path__ + "static/media/condition_wait.c2553018ed2004f429ba99bf044472be.svg";
export { ForwardRef as ReactComponent };